import { Input } from "antd"; // Correct import from 'antd'
import { SearchOutlined } from "@ant-design/icons"; // Import search icon
import { useState } from "react";
import { usePaginationPrzelewy } from "../../../context/PaginationContextPrzelewy";
import {Button} from "antd";

const SearchInput = ({ placeholder = "Search...", onSearch }) => {
    const { pagination, setPagination } = usePaginationPrzelewy();
    const [value, setValue] = useState(JSON.parse(localStorage.getItem('searchPrzelewy')));

    const handleChange = (e) => {
        setValue(e.target.value);
    };

    const submitSearch = () => {
        setPagination({ ...pagination, search: value, current: 1 });
    };

    const handleSearch = () => {
        if (onSearch) {
            onSearch(value); // Trigger the search callback if provided
        }
        // Update the pagination search
        setPagination({ ...pagination, search: value, current: 1 });
    };

    const handleClear = () => {
        setValue('');
        setPagination({ ...pagination, search: '', current: 1 });
        if (onSearch) {
            onSearch('');
        }
    };

    return (
        <div style={{ display: 'flex', width: '100%' }} className="search-wrapper">
        <Input
            value={value} // Bind the input value to state
            defaultValue={value}
            onChange={handleChange}
            width='100%'
            disabled={pagination.loading}
            onPressEnter={submitSearch} // Trigger search on Enter key press
            addonBefore={<SearchOutlined onClick={handleChange} />} // Trigger search on icon click
            placeholder="Wyszukaj wygenerowane przelewy"
            style={{
                borderRadius: '0px !important',
                maxWidth: '400px',
            }}
        />
        <Button onClick={handleSearch} disabled={pagination.loading} style={{height: '100%', borderLeft: 'none', borderRadius: '0'}}>Wyszukaj</Button> {/* Trigger search on button click */}
        <Button onClick={handleClear} disabled={pagination.loading} style={{height: '100%', borderLeft: 'none', borderRadius: '0 2px 2px 0'}}>Wyczyść</Button>
        </div>
    );
};

export default SearchInput;